import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { DictionaryService } from '../../../../../librarys/serves/public/dictionary.service';
import { SwCreateModalComponentService } from '../../../../../librarys/serves/sw-create-modal-component.service';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { TabInfoAddComponent } from '../tab-info-add/tab-info-add.component';
import { TabInfoViewComponent } from '../tab-info-view/tab-info-view.component';
import { KmsEnum } from '../../../serves/kms-enum';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $;
@Component({
  selector: 'app-tab-info-query',
  templateUrl: './tab-info-query.component.html',
  styleUrls: ['./tab-info-query.component.css']
})
export class TabInfoQueryComponent implements OnInit {
    // 检索条件
    searchDatas:any = [];
    // 时间字段key
    timeFiledName:string = '';

    // 表格数据内容
    datas = [];

    // 表格是否显示加载中
    isLoading: boolean = false;

    // 表格分页组件
    pageBase = {
        current: 1,
        size: 10
    }

    // 表格数据选中内容
    selectTableDatas = [];

    // 表格操作按钮
    toolbar:any = [];
    
    // 表单控件类型
    formControlTypes = KmsEnum.FORM_CONTROL_TYPES;

    // 接收父组件的数据：tabId（tab选项卡标识）
    @Input() tabId:any;

    // 接收父组件的数据：属性配置数据
    @Input() attrDatas:any;

    // 接收父组件的数据：实体ID
    @Input() instanceId:any;

    // 接收父组件的数据：状态 Add Edit Verify View
    @Input() state:string = 'View';

    // 删除确认组件
    @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
    constructor(
        private kmsService: KmsService,
        private instanceModuleService: InstanceModuleService,
        private message: SwMassageBoxService,
        private dicService: DictionaryService,
        private jwt: SwJwtService,
        private create: SwCreateModalComponentService
    ) { }

    ngOnInit() {
    }

    ngOnChanges() {
      if(this.tabId == this.attrDatas.attributeId && this.instanceId){
        if(this.state === 'View'){
          this.toolbar = [];
        }else{
          setTimeout(()=>{
              this.toolbar = [
                  { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
                  { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: [] },
              ];
          },0);
        }
        if (this.datas.length <= 0) {
          // 获取检索条件
          this.getSearchCondition();
          // 查询表格数据
          let timeField = this.attrDatas.attrChild ? this.attrDatas.attrChild.filter(item => item.fieldType == this.formControlTypes.dateRemark || item.fieldType == this.formControlTypes.date) : [];
          this.timeFiledName = timeField.length>0 ? timeField[0].englishCode : '';
          this.handleSelectClick();
        }
      }
    }

    // 获取检索条件
    getSearchCondition(){
      this.searchDatas = [];
      let items = this.attrDatas.attrChild ? this.attrDatas.attrChild : [];
      if(items.length>0){
        items.forEach(el => {
          let dictOptions = [];
          // 下拉框：获取字典项配置
          if(el.fieldType == this.formControlTypes.dropBox){
            dictOptions = this.dicService.getDictionaryValueOrName(el.dictionryCode);
          }
          // 树形下拉框：获取字典项配置
          if(el.fieldType == this.formControlTypes.treeSelect){
            dictOptions = this.dicService.getDictionaryTree(el.dictionryCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
            let options = JSON.parse(JSON.stringify(dictOptions));
            dictOptions.forEach(element => {
                let item = options.filter(el => el.id == element['pid']);
                element['pid'] = item.length>0 ? item[0].value : '0';
                element['parentId'] = element['pid'];
                element['id'] = element['value'];
            });
          }
          // 单选：获取选项配置
          if(el.fieldType == this.formControlTypes.radio){
            let options = el.dictionryCode.split('、');
            dictOptions = [
              {id: '0',text:options[0]},
              {id: '1',text:options[1]}
            ];
          }
          el['englishCode'] = el.englishCode;
          el['isDict'] = el.fieldType == this.formControlTypes.dropBox;
          el['isTreeDict'] = el.fieldType == this.formControlTypes.treeSelect;
          el['dictOptions'] = dictOptions;
          el['value'] = '';
        })
        this.searchDatas = items.filter(item => item.isCondition);
      }
    }

    // 获取复合属性表格数据
    getDatas() {
      this.isLoading = true;
      let queryParams = {
        current: this.pageBase.current,
        size: this.pageBase.size,
        instanceId: this.instanceId,
        relationshipId: this.attrDatas.englishCode,
        params: {}
      }
      this.searchDatas.forEach(element => {
        if($.trim(element.value)){
          queryParams.params[element.englishCode] = $.trim(element.value);
        }
      });
      this.kmsService.queryCompositeList(queryParams).subscribe( data => {
          this.isLoading = false;
          if (data.code == '200') {
              this.pageBase = data.data;
              this.datas = data.data.records;
              for(let i=0;i<this.datas.length;i++){
                this.datas[i]['editSortNum'] = false;
              }
          } else {
              this.message.waring(data.msg);
          }
      })
    }

    // 复合属性-字典项类型字段，将字典值转化为字典名序列
    getTypeStr(dictCode,value) {
        let options = this.dicService.getDictionaryValueOrName(dictCode);
        let str = this.instanceModuleService.getDictionaryName(options, value);
        return str;
    }

    // enter键触发搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.handleSelectClick();
        }
    }

    // 头部搜索查询方法
    handleSelectClick() {
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.getDatas();
    }

    // 头部搜索重置方法
    handleReloadClick() {
      this.searchDatas.forEach(item => {
        item.value = '';
      })
      this.pageBase = {
          current: 1,
          size: 10
      }
      this.getDatas();
    }

    // 表格按钮点击事件
    handleOperationClick(event) {
      switch (event) {
          case "add": this.handleAddClick(); break; // 新增
          case "delete": this.DeleteByIds(); break;  // 删除
      }
    }

    // 新增复合属性信息
    handleAddClick() {
      let params = {
        "upOrAdd": "Add",
        "attrDatas": this.attrDatas,
        "instanceId": this.instanceId,
        "nodeId": ''
      };
      this.create.createModal(TabInfoAddComponent, params, this.handleSelectClick.bind(this));
    }

    // 编辑复合属性信息
    handleEditClick(item) {
      //禁止冒泡
      event.stopPropagation();
      let params = {
        "upOrAdd": "Edit",
        "attrDatas": this.attrDatas,
        "instanceId": this.instanceId,
        "nodeId": item.nodeId
      };
      this.create.createModal(TabInfoAddComponent, params, this.getDatas.bind(this));
    }

    // 查看复合属性信息
    handleViewClick(item){
      //禁止冒泡
      event.stopPropagation();
      let params = {
        "attrDatas": this.attrDatas,
        "nodeId": item.nodeId
      };
      this.create.createModal(TabInfoViewComponent, params);
    }

    // 删除单条复合属性信息
    handleDeleteClick(item){
      //禁止冒泡
      event.stopPropagation();
      // 删除方法
      this.tirm1.openCLick('确认删除吗？', (data) => {
          if (data) {
              this.kmsService.deleteCompositeAttributeById(item.nodeId).subscribe(
                  result => {
                      if (result.code == 200) {
                          this.message.success('删除成功！');
                          this.getDatas();
                      }
                  }
              )
          }
      })
    }

    // 批量删除复合属性信息
    DeleteByIds() {
      let params = []
      if (this.selectTableDatas.length > 0) {
        for(let i = 0; i < this.selectTableDatas.length; i++) {
            params.push(this.selectTableDatas[i].nodeId)
        }
      } else {
          this.message.danger('请选择需要删除的数据！');
          return;
      }
      // 删除方法
      this.tirm1.openCLick('确认删除吗？', (data) => {
          if (data) {
              this.kmsService.deleteCompositeAttributeByIds(params).subscribe(
                  result => {
                      if (result.code == 200) {
                          this.message.success('删除成功！');
                          this.getDatas();
                      }
                  }
              )
          }
      })
    }

    // 表格选中数据
    handleSelectData(event) {
      this.selectTableDatas = event;
    }

    // 表格分页切换方法
    handlePageClick(event) {
      this.pageBase = event;
      this.getDatas();
    }

    // 根据属性的字段类型转换属性值
    getAttrValue(data,item){
      let str = '';
      // 字典类型
      if(item.fieldType == this.formControlTypes.dropBox || item.fieldType == this.formControlTypes.treeSelect){
        str = this.instanceModuleService.getDictionaryName(item.dictOptions,data[item.englishCode]);
        return str;
      }
      // 选择框类型（相关实体）
      else if(item.fieldType == this.formControlTypes.selectBox){
        if(data.relevants){
          let relatedInstance = data.relevants;
          for(let i=0;i<relatedInstance.length;i++){
            str += (i==0 ? relatedInstance[i].nodeName : ','+relatedInstance[i].nodeName);
          }
        }
        return str ? str : '无';
      }
      // 单选
      else if(item.fieldType == this.formControlTypes.radio){
        if(item.dictOptions.length > 0){
          let vals = item.dictOptions.filter(el => el.id == data[item.englishCode]);
          str = vals.length>0 ? vals[0].text : '无';
          return str;
        }else{
          return '无';
        }
      }
      // 地理位置
      else if(item.fieldType == this.formControlTypes.geoRemark || item.fieldType == this.formControlTypes.geo){
        if(data.places){
          let places = data.places;
          for(let i=0;i<places.length;i++){
            str += (i==0 ? places[i].placeName : ','+places[i].placeName);
          }
        }
        return str ? str : '无';
      }
      else{
        return data[item.englishCode] ? data[item.englishCode] : '无';
      }
    }

  // 修改排序号 
  saveSortNum(data) {
    if(!data.sortNum){
      this.message.info('请输入排序号!');
      return;
    }
    let params = {
      "compositeAttributeId": data.nodeId,
      "sortNum": data.sortNum
    }
    this.kmsService.updateCompositeAttrSortNum(params).subscribe(
        result => {
            if (result.code == 200) {
              this.message.success('操作成功！');
              this.getDatas();
            }else{
              this.message.success('操作失败！');
              this.getDatas();
            }
        }
    )
  }

  // 点击属性名称存储属性信息为添加质检记录做准备
  setAttrRecord(i,data,item){
    if(i===0 && this.state == 'Verify'){
      let name = data.nodeName ? data.nodeName : data[item.englishCode];
      if(!name){
        this.message.danger('属性信息获取失败！');
        return;
      }
      let verifyConfig = {
          uuid: this.instanceModuleService.uuid2(),
          contentName: name,      // 属性名称
          contentModule: item.attributeName,  // 错误模块
          foreignId: this.instanceId,  // 实体id
          contentId: data.nodeId,    // 属性id
          recordType: 1,    // 1 实体  2 标记
      }
      this.jwt.setToKen('instanceVerifyConfig',JSON.stringify(verifyConfig));
      if(name.length>20){
        name = name.substring(0,20)+'...';
      }
      this.message.info('选中'+item.attributeName+'数据：'+name);
    }
 }
}

